import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { ToolbarService } from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';

@Component({
  selector: 'jsg-scheduler-navigation',
  templateUrl: './scheduler-navigation.component.html',
  styleUrls: ['./scheduler-navigation.component.scss'],
})
export class SchedulerNavigationComponent implements OnInit {
  @Input() maxDate: Date;
  @Input() minDate: Date;
  private _selectedDate: Date;
  @Input() set selectedDate(value: Date) {
    this._selectedDate = value;

    if (this._selectedDate) {
      const weekEndDate = moment(this.selectedDate)
        .endOf('week')
        .format('MMM DD, YYYY');
      const weekStartDate = moment(this.selectedDate)
        .startOf('week')
        .format('MMM DD, YYYY');
      this.dateText = weekStartDate.toString() + ' - ' + weekEndDate.toString();
    }
  }
  get selectedDate(): Date {
    return this._selectedDate;
  }

  dateText;

  @ViewChild('datePicker', { static: false }) datePicker: DatePickerComponent;

  public popupRef: PopupRef;
  constructor(public toolbarService: ToolbarService) {}
  ngOnInit(): void {}

  public next(): void {
    this.toolbarService.navigate({
      type: 'next',
    });
  }

  public prev(): void {
    this.toolbarService.navigate({
      type: 'prev',
    });
  }

  public today(): void {
    this.toolbarService.navigate({
      type: 'today',
    });
  }

  public onDateChange(dateValue: Date): void {
    this.toolbarService.navigate({
      type: 'select-date',
      date: dateValue,
    });
  }

  public openCalendar(): void {
    this.datePicker.toggle();
  }
}
